import axios from 'axios';
import { Lead } from '../model/leads.model';
import { Project } from '../model/project.model';
import { Notes } from '../model/notes.model';

axios.defaults.baseURL = process.env.REACT_APP_BRAVERMAN;
const apiUrl = process.env.REACT_APP_BRAVERMAN;


const convertDateStringToDateTime = (date: string | Date): string => {
  if (!date) return new Date().toISOString();
  if (date instanceof Date) {
    return date.toISOString();
  }
  if (typeof date === 'string' && date.includes('T') && !date.includes('/')) {
    const parsed = new Date(date);
    if (!isNaN(parsed.getTime())) {
      return parsed.toISOString();
    }
  }
  const [day, month, year] = date.split('/').map(Number);
  const parsedDate = new Date(year, month - 1, day);
  if (isNaN(parsedDate.getTime())) {
    throw new Error('Invalid date format');
  }

  return parsedDate.toISOString();
};

//getAll
export const getAllLeads = () => {
  return axios.get(`${apiUrl}Leads/GetOpenLeads`);
}
export const getAllLeads2 = () => {//הוספתי כדי להביא את כולם ללא שום סינון על הסטטוס
  return axios.get(`${apiUrl}Leads/GetAllLeads`);
}

//addLead
export const addLead = (lead: Lead) => {
  return axios.post(`${apiUrl}Leads`, lead);
}

//Conversion to customer
export const convertToCustomer = (id: string) => {
  return axios.put(`${apiUrl}Leads/changeToCustomer/${id}`);
}


//update change
export const updateLeadChanges = async (lead: Lead, id: string) => {
  const leadToUpdate = {
    ...lead,
    lastContacted: convertDateStringToDateTime(lead.lastContacted),
    createdDate: convertDateStringToDateTime(lead.createdDate),
  };

  const res = await axios.put(`${apiUrl}Leads/${id}`, leadToUpdate);
  return res;
}

//filterStatus
export const filterByStatus = async (status: string) => {
  return await axios.get(`${apiUrl}Leads/FilterByStatus/?status=${encodeURIComponent(status)}`);
}

//convertToProject
export const convertToProject = async (project: Project) => {

  const projectToConvert = {
    ...project,
    createdAt: new Date(project.createdAt).toISOString(),
    updatedAt: new Date(project.updatedAt).toISOString(),
    endDate: new Date(project.endDate).toISOString(),

  };
  console.log('Sending project data to server:', projectToConvert);
  try {
    return await axios.post(`${apiUrl}Project/Add`, projectToConvert);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Server responded with an error:', error.response?.data);
    } else {
      console.error('An unexpected error occurred:', error);
    }
    throw error;
  }
}
export const addNewNote = async (note: Notes) => {
  const projectToConvert = {
    ...note,
    timestamp: new Date(note.timestamp).toISOString(),
  };
  try {

    return await axios.post(`${apiUrl}Note`, projectToConvert);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Server responded with an error:', error.response?.data);
    } else {
      console.error('An unexpected error occurred:', error);
    }
    throw error;
  }
}
// deleteLead
export const deleteLead = async (id: string) => {
  try {
    return await axios.delete(`${apiUrl}Leads/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Server responded with an error:', error.response?.data);
    } else {
      console.error('An unexpected error occurred:', error);
    }
    throw error;
  }
};
